import { FC } from 'react';

export const DashboardIcon: FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.66667 1H1V5.66667H5.66667V1Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 1H8.33333V5.66667H13V1Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 8.33333H8.33333V13H13V8.33333Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66667 8.33333H1V13H5.66667V8.33333Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PropertiesIcon: FC = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 14.6666V7.99998H9V14.6666M1 5.99998L7 1.33331L13 5.99998V13.3333C13 13.6869 12.8595 14.0261 12.6095 14.2761C12.3594 14.5262 12.0203 14.6666 11.6667 14.6666H2.33333C1.97971 14.6666 1.64057 14.5262 1.39052 14.2761C1.14048 14.0261 1 13.6869 1 13.3333V5.99998Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ChatsIcon: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 11.25C15.75 11.6478 15.592 12.0294 15.3107 12.3107C15.0294 12.592 14.6478 12.75 14.25 12.75H5.25L2.25 15.75V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H14.25C14.6478 2.25 15.0294 2.40804 15.3107 2.68934C15.592 2.97064 15.75 3.35218 15.75 3.75V11.25Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CalendarIcon: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 3H3.75C2.92157 3 2.25 3.67157 2.25 4.5V15C2.25 15.8284 2.92157 16.5 3.75 16.5H14.25C15.0784 16.5 15.75 15.8284 15.75 15V4.5C15.75 3.67157 15.0784 3 14.25 3Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 1.5V4.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 1.5V4.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 7.5H15.75"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TenantsIcon: FC = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1818 12.9997V11.6664C11.1818 10.9592 10.9136 10.2809 10.4363 9.78081C9.95891 9.28072 9.31146 8.99977 8.63636 8.99977H3.54545C2.87036 8.99977 2.22291 9.28072 1.74555 9.78081C1.26818 10.2809 1 10.9592 1 11.6664V12.9997M15 13V11.6667C14.9996 11.0759 14.8119 10.5019 14.4664 10.0349C14.1208 9.56796 13.637 9.23444 13.0909 9.08673M10.5454 1.08696C11.0929 1.23383 11.5783 1.56742 11.9248 2.03516C12.2714 2.50289 12.4595 3.07816 12.4595 3.67026C12.4595 4.26237 12.2714 4.83764 11.9248 5.30537C11.5783 5.7731 11.0929 6.1067 10.5454 6.25357M8.63636 3.66664C8.63636 5.13938 7.49673 6.33327 6.09091 6.33327C4.68509 6.33327 3.54545 5.13938 3.54545 3.66664C3.54545 2.19389 4.68509 1 6.09091 1C7.49673 1 8.63636 2.19389 8.63636 3.66664Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReportsIcon: FC = () => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66675 2.66665H10.0001C10.3537 2.66665 10.6928 2.80712 10.9429 3.05717C11.1929 3.30722 11.3334 3.64636 11.3334 3.99998V13.3333C11.3334 13.6869 11.1929 14.0261 10.9429 14.2761C10.6928 14.5262 10.3537 14.6666 10.0001 14.6666H2.00008C1.64646 14.6666 1.30732 14.5262 1.05727 14.2761C0.807224 14.0261 0.666748 13.6869 0.666748 13.3333V3.99998C0.666748 3.64636 0.807224 3.30722 1.05727 3.05717C1.30732 2.80712 1.64646 2.66665 2.00008 2.66665H3.33341M4.00008 1.33331H8.00008C8.36827 1.33331 8.66675 1.63179 8.66675 1.99998V3.33331C8.66675 3.7015 8.36827 3.99998 8.00008 3.99998H4.00008C3.63189 3.99998 3.33341 3.7015 3.33341 3.33331V1.99998C3.33341 1.63179 3.63189 1.33331 4.00008 1.33331Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FinancialIcon: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33325 11.3333L7.99992 14.6666L14.6666 11.3333M1.33325 7.99998L7.99992 11.3333L14.6666 7.99998M7.99992 1.33331L1.33325 4.66665L7.99992 7.99998L14.6666 4.66665L7.99992 1.33331Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TicketsIcon: FC = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.7999 4.2C8.67775 4.32462 8.60933 4.49216 8.60933 4.66666C8.60933 4.84117 8.67775 5.00871 8.7999 5.13333L9.86657 6.2C9.99119 6.32215 10.1587 6.39057 10.3332 6.39057C10.5077 6.39057 10.6753 6.32215 10.7999 6.2L13.3132 3.68666C13.6485 4.42746 13.75 5.25282 13.6042 6.05276C13.4585 6.8527 13.0724 7.58923 12.4974 8.16418C11.9225 8.73914 11.1859 9.12522 10.386 9.27097C9.58606 9.41672 8.7607 9.31522 8.0199 8.98L3.41324 13.5867C3.14802 13.8519 2.78831 14.0009 2.41324 14.0009C2.03816 14.0009 1.67845 13.8519 1.41324 13.5867C1.14802 13.3214 0.999023 12.9617 0.999023 12.5867C0.999023 12.2116 1.14802 11.8519 1.41324 11.5867L6.0199 6.98C5.68468 6.2392 5.58318 5.41384 5.72893 4.6139C5.87468 3.81396 6.26076 3.07743 6.83572 2.50248C7.41067 1.92752 8.1472 1.54144 8.94714 1.39569C9.74708 1.24994 10.5724 1.35144 11.3132 1.68666L8.80657 4.19333L8.7999 4.2Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TransactionsIcon: FC = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3333 0.666656L13 3.33332M13 3.33332L10.3333 5.99999M13 3.33332H3.66667C2.95942 3.33332 2.28115 3.61427 1.78105 4.11437C1.28095 4.61447 1 5.29275 1 5.99999V7.33332M3.66667 15.3333L1 12.6667M1 12.6667L3.66667 9.99999M1 12.6667L10.3333 12.6667C11.0406 12.6667 11.7189 12.3857 12.219 11.8856C12.719 11.3855 13 10.7072 13 9.99999V8.66666"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TenancyIcon: FC = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 14.6667V8H9V14.6667M1 6L7 1.33333L13 6V13.3333C13 13.687 12.8595 14.0261 12.6095 14.2761C12.3594 14.5262 12.0203 14.6667 11.6667 14.6667H2.33333C1.97971 14.6667 1.64057 14.5262 1.39052 14.2761C1.14048 14.0261 1 13.687 1 13.3333V6Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentsIcon: FC = () => (
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.66875 1H2.33375C1.98002 1 1.64077 1.14052 1.39065 1.39065C1.14052 1.64077 1 1.98002 1 2.33375V13.0037C1 13.3575 1.14052 13.6967 1.39065 13.9469C1.64077 14.197 1.98002 14.3375 2.33375 14.3375H10.3363C10.69 14.3375 11.0292 14.197 11.2794 13.9469C11.5295 13.6967 11.67 13.3575 11.67 13.0037V5.00125M7.66875 1L11.67 5.00125M7.66875 1L7.66875 5.00125H11.67M9.0025 8.33563H3.6675M9.0025 11.0031H3.6675M5.00125 5.66813H3.6675"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaymentsIcon: FC = () => (
  <svg
    width="10"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 0.666656V15.3333M8.33333 3.33332H3.33333C2.7145 3.33332 2.121 3.57916 1.68342 4.01674C1.24583 4.45433 1 5.04782 1 5.66666C1 6.28549 1.24583 6.87899 1.68342 7.31657C2.121 7.75416 2.7145 7.99999 3.33333 7.99999H6.66667C7.28551 7.99999 7.879 8.24582 8.31658 8.68341C8.75417 9.12099 9 9.71448 9 10.3333C9 10.9522 8.75417 11.5457 8.31658 11.9832C7.879 12.4208 7.28551 12.6667 6.66667 12.6667H1"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AccountIcon: FC = () => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 13V11.6667C11.3333 10.9594 11.0524 10.2811 10.5523 9.78105C10.0522 9.28095 9.37391 9 8.66667 9H3.33333C2.62609 9 1.94781 9.28095 1.44771 9.78105C0.947617 10.2811 0.666666 10.9594 0.666666 11.6667V13M8.66667 3.66667C8.66667 5.13943 7.47276 6.33333 6 6.33333C4.52724 6.33333 3.33333 5.13943 3.33333 3.66667C3.33333 2.19391 4.52724 1 6 1C7.47276 1 8.66667 2.19391 8.66667 3.66667Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingsIcon: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00008 9.99999C9.10465 9.99999 10.0001 9.10456 10.0001 7.99999C10.0001 6.89542 9.10465 5.99999 8.00008 5.99999C6.89551 5.99999 6.00008 6.89542 6.00008 7.99999C6.00008 9.10456 6.89551 9.99999 8.00008 9.99999Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9334 9.99999C12.8447 10.2011 12.8182 10.4241 12.8574 10.6404C12.8966 10.8566 12.9997 11.0562 13.1534 11.2133L13.1934 11.2533C13.3174 11.3772 13.4157 11.5242 13.4828 11.6861C13.5499 11.8479 13.5845 12.0214 13.5845 12.1967C13.5845 12.3719 13.5499 12.5454 13.4828 12.7072C13.4157 12.8691 13.3174 13.0162 13.1934 13.14C13.0696 13.264 12.9225 13.3623 12.7607 13.4294C12.5988 13.4965 12.4253 13.531 12.2501 13.531C12.0749 13.531 11.9014 13.4965 11.7395 13.4294C11.5776 13.3623 11.4306 13.264 11.3067 13.14L11.2667 13.1C11.1096 12.9463 10.9101 12.8432 10.6938 12.804C10.4775 12.7648 10.2545 12.7912 10.0534 12.88C9.85624 12.9645 9.68807 13.1048 9.56962 13.2837C9.45117 13.4625 9.3876 13.6721 9.38675 13.8867V14C9.38675 14.3536 9.24627 14.6928 8.99622 14.9428C8.74617 15.1928 8.40704 15.3333 8.05341 15.3333C7.69979 15.3333 7.36065 15.1928 7.11061 14.9428C6.86056 14.6928 6.72008 14.3536 6.72008 14V13.94C6.71492 13.7193 6.64349 13.5053 6.51509 13.3258C6.38668 13.1463 6.20724 13.0095 6.00008 12.9333C5.799 12.8446 5.57595 12.8181 5.35969 12.8573C5.14343 12.8965 4.94387 12.9996 4.78675 13.1533L4.74675 13.1933C4.62292 13.3173 4.47587 13.4156 4.314 13.4827C4.15214 13.5498 3.97864 13.5844 3.80341 13.5844C3.62819 13.5844 3.45469 13.5498 3.29283 13.4827C3.13096 13.4156 2.98391 13.3173 2.86008 13.1933C2.73611 13.0695 2.63777 12.9224 2.57067 12.7606C2.50357 12.5987 2.46903 12.4252 2.46903 12.25C2.46903 12.0748 2.50357 11.9013 2.57067 11.7394C2.63777 11.5775 2.73611 11.4305 2.86008 11.3067L2.90008 11.2667C3.05377 11.1095 3.15687 10.91 3.19608 10.6937C3.2353 10.4775 3.20882 10.2544 3.12008 10.0533C3.03557 9.85614 2.89525 9.68798 2.71639 9.56953C2.53753 9.45108 2.32794 9.38751 2.11341 9.38666H2.00008C1.64646 9.38666 1.30732 9.24618 1.05727 8.99613C0.807224 8.74608 0.666748 8.40695 0.666748 8.05332C0.666748 7.6997 0.807224 7.36056 1.05727 7.11051C1.30732 6.86047 1.64646 6.71999 2.00008 6.71999H2.06008C2.28074 6.71483 2.49475 6.6434 2.67428 6.515C2.85381 6.38659 2.99056 6.20715 3.06675 5.99999C3.15549 5.79891 3.18196 5.57586 3.14275 5.3596C3.10354 5.14333 3.00044 4.94378 2.84675 4.78666L2.80675 4.74666C2.68278 4.62283 2.58443 4.47577 2.51734 4.31391C2.45024 4.15205 2.4157 3.97854 2.4157 3.80332C2.4157 3.6281 2.45024 3.4546 2.51734 3.29274C2.58443 3.13087 2.68278 2.98382 2.80675 2.85999C2.93058 2.73602 3.07763 2.63768 3.23949 2.57058C3.40136 2.50348 3.57486 2.46894 3.75008 2.46894C3.9253 2.46894 4.0988 2.50348 4.26067 2.57058C4.42253 2.63768 4.56958 2.73602 4.69341 2.85999L4.73341 2.89999C4.89053 3.05368 5.09009 3.15678 5.30636 3.19599C5.52262 3.23521 5.74567 3.20873 5.94675 3.11999H6.00008C6.19726 3.03548 6.36543 2.89516 6.48388 2.7163C6.60233 2.53744 6.66589 2.32785 6.66675 2.11332V1.99999C6.66675 1.64637 6.80722 1.30723 7.05727 1.05718C7.30732 0.807132 7.64646 0.666656 8.00008 0.666656C8.3537 0.666656 8.69284 0.807132 8.94289 1.05718C9.19294 1.30723 9.33342 1.64637 9.33342 1.99999V2.05999C9.33427 2.27451 9.39784 2.48411 9.51629 2.66297C9.63474 2.84183 9.8029 2.98215 10.0001 3.06666C10.2012 3.1554 10.4242 3.18187 10.6405 3.14266C10.8567 3.10345 11.0563 3.00035 11.2134 2.84666L11.2534 2.80666C11.3772 2.68269 11.5243 2.58434 11.6862 2.51724C11.848 2.45014 12.0215 2.41561 12.1967 2.41561C12.372 2.41561 12.5455 2.45014 12.7073 2.51724C12.8692 2.58434 13.0163 2.68269 13.1401 2.80666C13.2641 2.93049 13.3624 3.07754 13.4295 3.2394C13.4966 3.40127 13.5311 3.57477 13.5311 3.74999C13.5311 3.92521 13.4966 4.09871 13.4295 4.26058C13.3624 4.42244 13.2641 4.56949 13.1401 4.69332L13.1001 4.73332C12.9464 4.89044 12.8433 5.09 12.8041 5.30626C12.7649 5.52253 12.7913 5.74558 12.8801 5.94666V5.99999C12.9646 6.19717 13.1049 6.36533 13.2838 6.48379C13.4626 6.60224 13.6722 6.6658 13.8867 6.66666H14.0001C14.3537 6.66666 14.6928 6.80713 14.9429 7.05718C15.1929 7.30723 15.3334 7.64637 15.3334 7.99999C15.3334 8.35361 15.1929 8.69275 14.9429 8.9428C14.6928 9.19285 14.3537 9.33332 14.0001 9.33332H13.9401C13.7256 9.33418 13.516 9.39774 13.3371 9.5162C13.1582 9.63465 13.0179 9.80281 12.9334 9.99999Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SupportIcon: FC = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1C3.23858 1 1 3.23858 1 6V7H2C2.55228 7 3 7.44772 3 8V11C3 11.5523 2.55228 12 2 12H1C0.447715 12 0 11.5523 0 11V6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6V12C12 13.3807 10.8807 14.5 9.5 14.5H7.36622C7.19331 14.7989 6.87014 15 6.5 15H5.5C4.94772 15 4.5 14.5523 4.5 14C4.5 13.4477 4.94772 13 5.5 13H6.5C6.87014 13 7.19331 13.2011 7.36622 13.5H9.5C10.3284 13.5 11 12.8284 11 12H10C9.44771 12 9 11.5523 9 11V8C9 7.44772 9.44772 7 10 7H11V6C11 3.23858 8.76142 1 6 1Z"
      fill="currentColor"
    />
  </svg>
);

export const BellIcon: FC = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.15334 14.3024C8.03613 14.5145 7.8679 14.6907 7.66549 14.8131C7.46308 14.9356 7.23359 15 7 15C6.76642 15 6.53693 14.9356 6.33452 14.8131C6.13211 14.6907 5.96388 14.5145 5.84667 14.3024M11 5.20074C11 4.08664 10.5786 3.01816 9.82843 2.23037C9.07828 1.44258 8.06087 1 7 1C5.93913 1 4.92172 1.44258 4.17157 2.23037C3.42143 3.01816 3 4.08664 3 5.20074C3 10.1016 1 11.5019 1 11.5019H13C13 11.5019 11 10.1016 11 5.20074Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DevelopmentIcon: FC = () => (
    <svg 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M19.4 15L21.5 16.3C21.8 16.5 22 16.9 22 17.3V19.7C22 20.1 21.8 20.5 21.5 20.7L19.4 22C19 22.2 18.6 22.2 18.2 22L15.8 21.2C15.4 21.1 15 21.2 14.7 21.5L13 23.4C12.8 23.8 12.4 24 12 24C11.6 24 11.2 23.8 11 23.4L9.3 21.5C9 21.2 8.6 21.1 8.2 21.2L5.8 22C5.4 22.2 5 22.2 4.6 22L2.5 20.7C2.2 20.5 2 20.1 2 19.7V17.3C2 16.9 2.2 16.5 2.5 16.3L4.6 15C5 14.8 5.4 14.8 5.8 15L8.2 15.8C8.6 15.9 9 15.8 9.3 15.5L11 13.6C11.2 13.2 11.6 13 12 13C12.4 13 12.8 13.2 13 13.6L14.7 15.5C15 15.8 15.4 15.9 15.8 15.8L18.2 15C18.6 14.8 19 14.8 19.4 15Z" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
    </svg>
);
